import { MenuIcon } from '@/components/layout/navIcons'
import { UserMenu } from '@/components/layout/UserMenu'
import { useSidebarStore } from '@/stores/sidebarStore'

/**
 * Topbar: the drawer trigger and the account menu.
 *
 * The desktop collapse control lives at the foot of the sidebar, so the only
 * nav control here is the drawer trigger shown below `lg`.
 *
 * **No page heading or breadcrumb trail** (client request, 2026-10-08): each
 * screen titles itself in the page, so naming it here repeated it.
 *
 * **No global search** (client decision, 2026-09-11). The design showed one and
 * it shipped disabled, since no search endpoint exists — but a permanently dead
 * control is worse than none, so it was removed rather than left as scenery.
 * Each listing carries its own search instead.
 *
 * **No help or notification icons** (client request, 2026-10-06): neither had a
 * screen or an endpoint behind it.
 */
export function Topbar() {
  const openMobile = useSidebarStore((state) => state.openMobile)

  return (
    <header
      className="flex shrink-0 items-center gap-4 border-b border-border bg-surface px-4 print:hidden"
      style={{ height: 'var(--layout-topbar-height)' }}
    >
      {/* Below lg the sidebar is an off-canvas drawer. */}
      <button
        type="button"
        onClick={openMobile}
        aria-label="Open navigation"
        className="shrink-0 text-topbar-fg transition-colors hover:text-topbar-fg-strong lg:hidden"
      >
        <MenuIcon className="size-6" />
      </button>

      {/* `ml-auto` holds these at the right edge. */}
      <div className="ml-auto flex shrink-0 items-center gap-1">
        <UserMenu />
      </div>
    </header>
  )
}
